import React, { useEffect, useState } from 'react';
import { INITIATIVES } from './content';
import './rcm.css';

// The five initiatives, one per frame: the problem in plain words, how it is
// done today, what nventr builds (and which module carries it), what gets
// counted. `frame` from ?fig=initiatives&frame= (0–4).
export default function Initiatives({ frame = null }) {
  const [i, setI] = useState(() => (frame != null ? Math.min(Math.max(0, frame), INITIATIVES.length - 1) : 0));
  useEffect(() => { if (frame != null) setI(Math.min(Math.max(0, frame), INITIATIVES.length - 1)); }, [frame]);
  const it = INITIATIVES[i];
  return (
    <div className="as-screen rcm-inits" data-nova-note="The five initiatives on the teaser. Each frame: the problem, how it is done today, what nventr builds and on which module, what is counted. Frames 0–4 map to initiatives 1–5.">
      <div className="as-tabs" role="tablist">
        {INITIATIVES.map((t, k) => (
          <button key={t.id} type="button" role="tab" aria-selected={k === i} className={k === i ? 'on' : ''} onClick={() => setI(k)}>
            <small>{t.n}</small> {t.label}
          </button>
        ))}
        <span className="as-tabctl" role="group" aria-label="frame controls">
          <button type="button" onClick={() => setI((i + INITIATIVES.length - 1) % INITIATIVES.length)} aria-label="previous initiative">‹</button>
          <button type="button" onClick={() => setI((i + 1) % INITIATIVES.length)} aria-label="next initiative">›</button>
          <small>{i + 1} / {INITIATIVES.length}</small>
        </span>
      </div>
      <div className="rcm-init">
        <div className="rcm-init-head">
          <h3><span className="rcm-n">{it.n}</span>{it.title}</h3>
          <div className="rcm-init-tags">
            <span className="as-chip tone-teal">{it.module}</span>
            <span className="as-chip">{it.lever}</span>
            <span className="rcm-fits">fits: {it.fits}</span>
          </div>
        </div>
        <div className="rcm-init-grid">
          <section><h4>The problem</h4><p>{it.problem}</p></section>
          <section><h4>How it is done today</h4><p>{it.today}</p></section>
          <section className="is-teal"><h4>What nventr builds</h4><p>{it.builds}</p></section>
          <section className="is-amber"><h4>What gets counted</h4><p>{it.counted}</p><small>Ledger line: {it.priced}</small></section>
        </div>
      </div>
    </div>
  );
}
